import React, { useEffect, useState } from 'react'
import Services from '../components/services'
import About from '../components/About'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import WhyUs from '../components/WhyUs'

function Home() {
    // const [showPromo, setShowPromo] = useState(false)

    // useEffect(() => {
    //     const firstTimer = localStorage.getItem("promoAds")
    //     if (firstTimer !== "true") {
    //         const timer = setTimeout(() => {
    //             setShowPromo(true)
    //             localStorage.setItem("promoAds", "true")
    //         }, 100)
    //         return () => clearTimeout(timer)
    //     }
    // }, [])

    return (
        <main className="main" id="top">
            <Navbar />
            <Hero />
            <About />
            <Services />
            <WhyUs />
            <Footer />
            {/* {showPromo && (
                <div style={{ position: "fixed", inset: "0", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0,0,0,0.5)", zIndex: "50" }}>
                    <div style={{ backgroundColor: "#fff", borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", maxWidth: "30rem", width: "100%", padding: "24px", textAlign: "center", position: "relative", paddingBlock: 50 }}>
                        <button className='btn' style={{ position: "absolute", fontSize: "30px", color: "#6b7280", cursor: "pointer", top: 0, right: 0 }} onClick={() => setShowPromo(false)}>&times;</button>
                        <h5 style={{ fontSize: "1.5rem", fontWeight: "700", margin: "0 0 12px" }}>First 10,000 Get It FREE!</h5>
                        <p style={{ fontSize: "1.125rem", margin: "16px 0" }}>Your first request on Hustle Connects costs <strong>GHȻ 0</strong>.</p>
                        <p style={{ color: "#dc2626", fontWeight: "600", margin: "8px 0" }}>Spots are moving fast!</p>
                        <a href="/waiting" style={{ display: "inline-block", backgroundColor: "#D1B000", color: "#fff", fontWeight: "600", padding: "12px 24px", borderRadius: "8px", marginTop: "16px", textDecoration: "none", transition: "background-color 0.2s" }}>
                            Join the Waitlist Now
                        </a>
                    </div>
                </div>
            )} */}
        </main>
    )
}

export default Home
